import { JSEncrypt } from 'jsencrypt'
import { clearLS } from '@/utils/storage'
import { isBlank, isString } from './validate'
// 常见工具方法
export const getPrevIndex = (arr, curr) => {
	if (Object.prototype.toString.call(arr) !== '[object Array]') {
		return -1
	}

	if (arr.length < 2) return -1
	if (arr.indexOf(curr) <= 0) {
		return -1
	}
	return arr.indexOf(curr) - 1
}

// 参数对象去空 字符串去前后空格
export const handleParams = params => {
	let obj = {}
	for (let key in params) {
		if (!isBlank(params[key])) {
			if (isString(params[key])) {
				obj[key] = params[key].trim()
			} else {
				obj[key] = params[key]
			}
		}
	}
	return obj
}

// 数据字典转换
export const nameTrans = (value, arr) => {
	return (arr.find(item => item.defaultValue == value) || {})?.name || '--'
}

// 字符串指定位置插入字符
export const insertStr = (soure, start, newStr) => {
	return soure.slice(0, start) + newStr + soure.slice(start)
}

// 格式化excel导出时间
export const formatExcelDate = (numb, format = 'yyyy-mm-dd') => {
	if (numb > 0) {
		const time = new Date((numb - 1) * 24 * 3600000 + 1)
		let h = time.getHours() + 16
		let yeraData = new Date(1900, 0, numb - 1)
		let year = yeraData.getFullYear()
		let month = yeraData.getMonth() + 1
		month = month < 10 ? '0' + month : month
		let day = yeraData.getDate()
		day = day < 10 ? '0' + day : day
		if (h > 23) {
			h = h - 24
		}
		h < 10 ? (h = '0' + h) : null
		let m = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
		let s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
		if (format === 'yyyy-mm-dd') {
			return `${year}-${month}-${day}`
		}
		return `${year}-${month}-${day} ${h}:${m}:${s}`
	} else {
		return '非法日期格式'
	}
}

export const formatTime = (type = 'y-m-d', date = new Date()) => {
	if (date instanceof Date === false) {
		date = new Date(+date)
	}
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	const formatNumber = n => {
		const str = n.toString()
		return str[1] ? str : '0' + str
	}
	const yearMonthDay = [year, month, day].map(formatNumber).join('-')
	const monthDay = [month, day].map(formatNumber).join('-')
	const hourMinuteSecond = [hour, minute, second].map(formatNumber).join(':')

	switch (type) {
		case 'h:m:s':
			return hourMinuteSecond
		case 'y-m-d h:m:s':
			return yearMonthDay + ' ' + hourMinuteSecond
		case 'm-d':
			return monthDay
		case 'y-m-d':
		default:
			return yearMonthDay
	}
}

// 密码长度在8到18位之间，并且包含大/小写字母、数字以及特殊字符中的任意三项
export const isComplexPass = value => {
	const passwordRegs = [new RegExp(/\d+/g), new RegExp(/[a-z]+/g), new RegExp(/[A-Z]+/g), new RegExp(/[^a-zA-Z0-9]/)]

	const validRules = passwordRegs.reduce((prev, cur) => {
		if (cur.test(value)) {
			prev += 1
		}
		return prev
	}, 0)

	return value?.length >= 8 && value?.length <= 18 && validRules >= 3
}

/**
 * 满足密码长度在8到18位之间，并且包含大/小写字母、数字以及特殊字符的随机密码生成
 * @returns
 */
export const generatePassword = () => {
	const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz'
	const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
	const digits = '0123456789'
	const specialCharacters = '!@#$&*?'

	let password = [
		lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)],
		uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)],
		specialCharacters[Math.floor(Math.random() * specialCharacters.length)],
	]

	const remainingLength = 8 - password.length

	for (let i = 0; i < remainingLength; i++) {
		password.push(digits[Math.floor(Math.random() * digits.length)])
	}

	password.sort(() => Math.random() - 0.5)

	return password.join('')
}

/**
 * 加密
 * @param { String } data 需要加密的数据
 * @param { String } key 公钥key
 * @param { String } iv
 */
export const encrypt = data => {
	const publicKey =
		'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAMRpvV7/iqttMdvvCQzm2E7ZqnRWGp15RwHrYf9aUsN8KScoQ49VN8uhLJu07HKoWwlul28vfgBqnUKJ25R36b8CAwEAAQ=='
	const encryptor = new JSEncrypt()
	encryptor.setPublicKey(publicKey)
	return encryptor.encrypt(data)
}

// 根据域名是否包含eslink子域名判断是否为etbc租户
export const isEtbcTenant = window.ETBC_DOMAIN.some(domain => location.origin.indexOf(domain) > -1)

export const etbcLogout = async () => {
	clearLS()
	location.replace(window.ETBC_LOGOUT_URL)
}

// 根据域名是否包含 szrqbjq 判断是否为深圳燃气租户
export const isSzrqTenant = location.origin.indexOf('szrqbjq') > -1

export const iotSystemName =
	location.origin.indexOf('alyshuiwu.iot') > -1
		? '金卡NB-IOT平台'
		: location.origin.indexOf('test0620.iot') > -1
		? '金卡物联网平台软件[简称:物联网平台软件]'
		: 'IoT监控平台'

export const jumpScreen = async () => {
	const url = window.location.protocol === 'http:' ? 'http://cls.test.eslink.net.cn' : 'https://gsscreen.eslink.com'
	window.open(url, '_blank') //  'noopener=yes,noreferrer=yes'
}

export function debounce(fn, t) {
	const delay = t || 300
	let timer
	return (...args) => {
		if (timer) {
			clearTimeout(timer)
		}
		const context = this
		timer = setTimeout(() => {
			timer = null
			fn.apply(context, args)
		}, delay)
	}
}

/**
 * 生成随机字符串
 * @param {number} length - 字符串长度，默认8
 * @param {string} charset - 字符集，默认包含大小写字母和数字
 * @returns {string} 随机字符串
 */
export function randomString(length = 8, charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz') {
	let result = ''
	const charsetLength = charset.length
	for (let i = 0; i < length; i++) {
		result += charset.charAt(Math.floor(Math.random() * charsetLength))
	}
	return result
}

/**
 * 原生JS复制文本到剪贴板
 * @param {string} text - 要复制的文本内容
 * @returns {Promise<{success: boolean, msg: string}>} 复制结果
 */
export function copyToClipboard(text) {
	// 方案1：现代浏览器优先使用 Clipboard API（需 HTTPS 环境/本地 localhost）
	if (navigator.clipboard && window.isSecureContext) {
		return navigator.clipboard
			.writeText(text)
			.then(() => ({
				success: true,
				msg: '复制成功',
			}))
			.catch(err => ({
				success: false,
				msg: `复制失败：${err.message || 'Clipboard API 调用失败'}`,
			}))
	}

	return new Promise(resolve => {
		const textarea = document.createElement('textarea')
		textarea.value = text
		textarea.style.position = 'fixed'
		textarea.style.top = '-9999px'
		textarea.style.left = '-9999px'
		textarea.style.opacity = '0'
		document.body.appendChild(textarea)

		try {
			textarea.focus()
			textarea.select()
			const isSuccess = document.execCommand('copy')

			resolve({
				success: isSuccess,
				msg: isSuccess ? '复制成功' : '复制失败：execCommand 执行失败',
			})
		} catch (err) {
			resolve({
				success: false,
				msg: `复制失败：${err.message}`,
			})
		} finally {
			document.body.removeChild(textarea)
		}
	})
}
